import type { ReactNode } from 'react';
import { StatusPulse } from '@/components/ui/status-pulse';

export function LiveNavigationLabel({ children }: { children: ReactNode }): React.ReactNode {
  return (
    <span className="inline-flex items-center gap-1.5 pl-0.5">
      <StatusPulse data-testid="live-navigation-indicator" />
      {children}
    </span>
  );
}
